define.alias("ember-concurrency/helpers/cancel-all", "calendar/helpers/cancel-all");